import styled from "styled-components";


export const ActivateAccountWrapper = styled.div`
`